const translations = {
  EQUIPMENT_MANAGEMENT: 'Hotspot Management',
  GATEWAY: 'Gateway'
};

export default translations;
